import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=17116938"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"
import style0 from "./GenericTable.vue?vue&type=style&index=0&id=17116938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports